let snowflakesifyId = 1;

export default function snowflakesify(Authentication) {
  'ngInject';

  return {
    restrict: 'EC',
    link($scope, $element) {
      // when we add button classes via ng-class (i.e. modal-shift-view.html)
      // we need to run it after the classes are added, hence $evalAsync
      let style;
      const makeItSnow = () => {
        if (Authentication.user?.settings.clientFlags.disableChristmasTheme) {
          return;
        }

        if (!$element.hasClass('snowflakesify') && !$element.hasClass('btn-primary')) {
          return;
        }

        const id = snowflakesifyId++;
        $element.attr('snowflakesify-id', id);

        const css = `
          [snowflakesify-id="${id}"]:after {
            position: absolute;
            content: "";
            top: 0;
            left: 0;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            box-shadow: ${getBoxShadows($element[0].offsetHeight, $element[0].offsetWidth)}
          }
        `;

        style = document.createElement('style');
        style.innerHTML = css;

        document.head.appendChild(style);

        $scope.$on('$destroy', () => {
          if (style) {
            document.head.removeChild(style);
            style = null;
          }
        });
      };

      $scope.$evalAsync(() => {
        makeItSnow();
      });

      $scope.$watch(
        () => Authentication.user?.settings.clientFlags.disableChristmasTheme,
        () => {
          if (Authentication.user?.settings.clientFlags.disableChristmasTheme) {
            if (style) {
              document.head.removeChild(style);
              style = null;
            }
          } else {
            makeItSnow();
          }
        }
      );
    },
  };
}

function getBoxShadows(height, width) {
  let snowflakesCount = Math.floor((width * height) / 1000);
  const maxRadius = Math.min(height, width) / 10;
  const coordsArray = [];

  while (snowflakesCount--) {
    const [x, y] = [Math.random() * width, Math.random() * height].map(Math.floor);
    coordsArray.push([x, y]);
  }

  return coordsArray
    .map(([x, y]) => `${x}px ${y}px 0 ${getRandomRadius(maxRadius)}px rgba(255, 255, 255, 0.25)`)
    .join(', ');
}

function getRandomRadius(maxRadius) {
  return Math.round(Math.random() * maxRadius);
}
